import { OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserAuthority } from '@app/domain/model/user-authority';
var RequireAuthorityDirective = /** @class */ (function () {
    function RequireAuthorityDirective(templateRef, viewContainer, authenticator) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.authenticator = authenticator;
        this.allowAuthorize = true;
    }
    Object.defineProperty(RequireAuthorityDirective.prototype, "hasAuthority", {
        set: function (authority) {
            this.authorities = [UserAuthority.fromString(authority)];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RequireAuthorityDirective.prototype, "hasAnyAuthority", {
        set: function (authorities) {
            this.authorities = authorities.map(function (authority) { return UserAuthority.fromString(authority); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RequireAuthorityDirective.prototype, "hasNoAuthority", {
        set: function (authority) {
            this.authorities = [UserAuthority.fromString(authority)];
            this.allowAuthorize = false;
        },
        enumerable: true,
        configurable: true
    });
    RequireAuthorityDirective.prototype.ngOnInit = function () {
        var user = this.authenticator.getCurrentUser();
        var authorized = user.hasAnyOfAuthorities(this.authorities);
        if (authorized === this.allowAuthorize) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    };
    return RequireAuthorityDirective;
}());
export { RequireAuthorityDirective };
